import { render } from "./message-face.vue?vue&type=template&id=ec7124a2&scoped=true&ts=true"
import script from "./message-face.vue?vue&type=script&lang=ts"
export * from "./message-face.vue?vue&type=script&lang=ts"

import "./message-face.vue?vue&type=style&index=0&id=ec7124a2&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7124a2"]])

export default __exports__